<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow"
                   :key="item.children[0].name"
                   :to="item.path+'/'+item.children[0].path">
        <el-menu-item :class="{'submenu-title-noDropdown':!isNest}" :index="item.path+'/'+item.children[0].path">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"
                    class="d"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title&&isSlot"
                slot="title"
                :title="generateTitle(item.children[0].meta.title)"
                class="ellip">
                  {{ generateTitle(item.children[0].meta.title) }}
          </span>
          <span v-if="item.children[0].meta&&item.children[0].meta.title&&!isSlot"
                :title="generateTitle(item.children[0].meta.title)"
                class="ellip">
                {{ generateTitle(item.children[0].meta.title) }}
          </span>
        </el-menu-item>
      </router-link>
      <el-submenu v-else :key="item.name" :index="item.name||item.path">
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title&&isSlot" slot="title">{{ generateTitle(item.meta.title) }}</span>
          <span v-if="item.meta&&item.meta.title&&!isSlot">{{ generateTitle(item.meta.title) }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item v-if="child.children&&child.children.length>0" :key="child.path" :is-nest="true"
                        :routes="[child]" class="nest-menu"></sidebar-item>

          <router-link v-else :key="child.name" :to="item.path+'/'+child.path">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title&&isSlot"
                    slot="title">{{ generateTitle(child.meta.title) }}</span>
              <span v-if="child.meta&&child.meta.title&&!isSlot">{{ generateTitle(child.meta.title) }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
import {generateTitle} from '@/utils/i18n'

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    },
    isSlot: {//是否设置slot属性
      type: Boolean,
      default: false
    },

  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    generateTitle
  }
}
</script>
<style lang="scss">
.ellip {
  //单行
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue